<div class="modal-container">

  <div class="modal-body">
    <p class="section-subtitle">Para validar se você possui plugins ou extensões ativos,
      realize os procedimentos abaixo, de acordo com o navegador utilizado:
    </p>

    <div class="row justify-content-center w-100 text-left my-4">
      <div class="col-12 col-md-5 mb-4 mb-md-0">
        <h3 class="section-subtitle text-center">Edge ou Google Chrome</h3>
        <ul class="browsers-list pl-3">
          <li>Clique em "Configurações" (nos três pontinhos), no canto superior direito;</li>
          <li>Selecione "Extensões";</li>
          <li>Clique em Gerenciar Extensões;</li>
          <li>Serão exibidos todos os plugins e extensões do navegador.</li>
        </ul>
      </div>
      <div class="col-12 col-md-5">
        <h3 class="section-subtitle text-center">Safari</h3>
        <h3 class="section-subtitle">MAC</h3>
        <ul class="browsers-list ml-5">
          <li>Clique em "Safari", no canto superior esquerdo;</li>
          <li>Selecione "Configurações";</li>
          <li>Clique em "Extensões";</li>
          <li>Serão exibidos todos os plugins e extensões do navegador.</li>
        </ul>

        <h3 class="section-subtitle">iPad ou iPhone</h3>
        <ul class="browsers-list ml-5">
          <li>Selecione "Ajuste" no dispositivo;</li>
          <li>Clique em "Apps";</li>
          <li>Selecione o app "Safari";</li>
          <li>Clique em "Extensões";</li>
          <li>Serão exibidos todos os plugins e extensões do navegador.</li>
        </ul>
      </div>
    </div>

    <h3 class="section-subtitle">
      Para a utilização do Portal do Investidor é necessário que todos os
      plugins ou extensões do navegador estejam desativados.
    </h3>
  </div>

  <div class="button-container">
    <button class="btn-ok" (click)="close()">OK</button>
  </div>

</div>

